
import HeroProject from '../../components/HeroComponents/HeroProject'
import Projects from "../../components/Projects";

function ProjectPage() {
  return (
    <>
     <HeroProject />
     <Projects />
    

    </>
  )
}

export default ProjectPage